import React, { useEffect, useState } from "react";
import { IProduct } from "../../../models/product/IProduct";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { GetCharacteristicsFromString, IProductCharacteristics, SetCharacteristicsToString } from "../../../models/product/IProductCharacteristics";
import AddButton from "../../../components/AddButton";
import DeleteButton from "../../../components/DeleteButton";
import SubmitButton from "../../../components/SubmitButton";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../_store";
import { removeImage } from "../../../_store/thunks/image.thunks";
import { productUpdate, productsGetList } from "../../../_store/thunks/product.thunk";
import { IMAGE } from "../../../constants/endpoints";

interface IProductEdit {
    setErrorAlert: any;
    product: IProduct | null;
    editOnClose: any;
}

export default function ProductEdit(props: IProductEdit) {

    const dispatch = useDispatch<AppDispatch>();
    const categories = useSelector((state: RootState) => state.category.categories);

    const [product, setProduct] = useState<IProduct | null>(null);
    const [currentProductCharacteristics, setCurrentProductCharacteristics] = useState<IProductCharacteristics[]>([]);
    const [hasChanges, setHasChanges] = useState(false);

    useEffect(() => {
        if (props.product) {
            setProduct(props.product);
            setCurrentProductCharacteristics(GetCharacteristicsFromString(props.product.characteristics));
        }
    }, [props.product])

    function updateProduct(event: any) {
        event.preventDefault();
        if (product) {
            let images = event.target.images.files;
            const formData = new FormData();

            let characteristics: IProductCharacteristics[] = [];

            currentProductCharacteristics.forEach(c => {
                characteristics.push(
                    {
                        id: c.id,
                        name: event.target["charactName_" + c.id].value,
                        value: event.target["charactValue_" + c.id].value,
                    })
            });

            Array.from(images).map((x: any) => formData.append('images', x));
            formData.append("id", `${product.id}`);
            formData.append("categoryId", `${product.categoryId}`);
            formData.append("name", product.name);
            formData.append("description", product.description);
            formData.append("showInMainPage", `${product.showInMainPage}`);
            formData.append("shortDescription", product.shortDescription);
            formData.append("characteristics", SetCharacteristicsToString(characteristics));

            dispatch(productUpdate(formData)).then((x: any) => {
                if (x.error) {
                    props.setErrorAlert(x.error.message);
                }
                else {
                    dispatch(productsGetList())
                    resetEditPage();
                }
            });
        }
    }

    function editProductState(fieldName: string, value: any) {
        setProduct((prev) => ({ ...prev, [fieldName]: value } as IProduct));
        setHasChanges(true);
    }

    function addNewCharacteristics() {
        if (product) {
            let updated = [...currentProductCharacteristics, { id: Math.random(), name: "", value: "" }]
            setCurrentProductCharacteristics(updated);
            setHasChanges(true);
        }
    }

    function deleteCharacteristics(charact: any) {
        if (product) {
            let updated = currentProductCharacteristics.filter((x: IProductCharacteristics) => x.id !== charact.id);
            setCurrentProductCharacteristics(updated);
            setHasChanges(true);
        }
    }
    function deleteImage(id: number) {
        dispatch(removeImage(id)).then((x: any) => {
            if (x.error) {
                props.setErrorAlert(x.error.message);
            }
            else {
                let images = product?.images.filter(x => x !== id);
                setProduct((old) => ({ ...old, images: images }) as IProduct)
                dispatch(productsGetList())
                setHasChanges(true);
            }
        });
    }

    function resetEditPage() {
        setProduct(null);
        setCurrentProductCharacteristics([]);
        setHasChanges(false);
        props.editOnClose();
    }

    return (
        <>
            {product &&
                <Modal show={product != null} onHide={() => resetEditPage()}
                    size="lg"
                    backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Редактировать оборудование</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={updateProduct}>

                            <Form.Group>
                                <Form.Label>Категория:</Form.Label>
                                <Form.Select
                                    value={product.categoryId}
                                    onChange={(event) => editProductState("categoryId", Number(event.target.value))}>
                                    {categories?.map(category =>
                                        (<option key={category.id} value={category.id}>{category.name}</option>))}
                                </Form.Select>
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Название:</Form.Label>
                                <Form.Control type="text"
                                    value={product.name}
                                    onChange={(event) => editProductState("name", event.target.value)} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Описание:</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    value={product.description}
                                    onChange={(event) => editProductState("description", event.target.value)} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Короткое описание (отображается на главной):</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    value={product.shortDescription}
                                    onChange={(event) => editProductState("shortDescription", event.target.value)} />
                            </Form.Group>
                            <hr></hr>
                            <p>
                                <span>Характеристики:</span>
                                <AddButton
                                    size='sm'
                                    onClick={() => addNewCharacteristics()} />
                            </p>
                            <p>
                                <Row>
                                    <Col>Название:</Col>
                                    <Col>Значение:</Col>
                                    <Col></Col>
                                </Row>
                                {currentProductCharacteristics.map((charact: IProductCharacteristics) => (
                                    <Row key={charact.id} style={{ paddingBottom: "10px" }}>
                                        <Col>
                                            <Form.Control
                                                size="sm"
                                                type="text"
                                                defaultValue={charact.name}
                                                onInput={() => setHasChanges(true)}
                                                name={"charactName_" + charact.id}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                size="sm"
                                                type="text"
                                                defaultValue={charact.value}
                                                onInput={() => setHasChanges(true)}
                                                name={"charactValue_" + charact.id}
                                            />
                                        </Col>
                                        <Col>
                                            <DeleteButton
                                                size='sm'
                                                onClick={() => deleteCharacteristics(charact)} />
                                        </Col>
                                    </Row>
                                ))}
                            </p>
                            <hr></hr>
                            <Form.Group className="mb-3" controlId="showInMainPage">
                                <Form.Label>Показывать на главной:</Form.Label>
                                <Form.Check
                                    checked={product.showInMainPage}
                                    onChange={(event) => editProductState("showInMainPage", event.target.checked)} />
                            </Form.Group>

                            <p>
                                <Row>
                                    {product.images && product.images?.map((image: number) => (
                                        <Col style={{ maxWidth: "220px" }}>
                                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                <img
                                                    alt="not found"
                                                    width={"200px"}
                                                    src={`/api/${IMAGE}?id=${image}`}
                                                />
                                                <Button
                                                    variant='danger'
                                                    style={{ position: "absolute" }}
                                                    size='sm'
                                                    onClick={() => deleteImage(image)} >
                                                    Удалить
                                                </Button>
                                            </div>

                                        </Col>
                                    ))}
                                </Row>

                            </p >

                            <Form.Group controlId="images" className="mb-3">
                                <Form.Label>Загрузите изображения:</Form.Label>
                                <Form.Control type="file" multiple accept=".jpef, .png, .jpg" onInput={() => setHasChanges(true)} />
                            </Form.Group>

                            <SubmitButton disabled={!hasChanges} />
                        </Form>
                    </Modal.Body>
                </Modal>}
        </>

    );
}